define('customPlugins/atnAccordionWidget',[
        'knockout', 'lodash'
    ],
    function(ko, _) {
        'use strict';
        var contentColor = '#fefcdd';
        var colorWhite = '#ffffff';
        ko.bindingHandlers.atnAccordionWidget = {
            update: function(element, valueAccessor) {
                var toggleTargetRole = valueAccessor().toggleTarget,
                    highlightCssClass = valueAccessor().highlightCssClass,
                    accordionData = ko.utils.unwrapObservable(valueAccessor().accordionElement),
                    matchedTargets = element.querySelectorAll('[atn-role=' + toggleTargetRole + ']');
                
                if (accordionData) {
                    var segmentElement = matchedTargets[0];
                    /**
                     * trigger dependency of custom plugin on isSectionExpanded of each row.
                     */
                    var sectionExpanded = accordionData.isSectionExpanded();
                    if (segmentElement) {
                        segmentElement.style.display = sectionExpanded ? 'block' : 'none';
                    }
                    if (accordionData.isHighlighted() && segmentElement) {
                        segmentElement.style.backgroundColor = contentColor;
                        segmentElement.className += ' ' + highlightCssClass;
                        segmentElement.scrollIntoView(false);
                        _.delay(removeClassByPrefix, 1000, accordionData, segmentElement, highlightCssClass);
                    }
                }

                function removeClassByPrefix(value, el, prefix) {
                    el.style.backgroundColor = colorWhite;
                    el.className = el.className.replace(prefix, '');
                    value.isHighlighted(false);
                    return el;
                }
            }
        };
    });
